<template>
  <div class="page-notice" v-if="show && notice">
    <div class="content" @click.stop="jumpNotice">[通知] {{ notice }}</div>
    <span class="icon" @click.stop="closeNotice">x</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'notice',
  props: {
    // position 1 首页，2 详情，3 验票
    position: {},
    line_id: {}
  },
  data () {
    return {
      show: false,
      notice: '',
      notice_id: null
    }
  },
  watch: {
    current_city () {
      this.init()
    }
  },
  computed: {
    ...mapGetters([
      'enterprise_id',
      'current_city'
    ])
  },
  methods: {
    ...mapActions([
      'getNotice'
    ]),
    closeNotice () {
      this.show = false
      // 触发父组件显示通知
      this.$emit('noticed', false)
    },
    jumpNotice () {
      var path = '/notice/' + this.notice_id
      if (this.enterprise_id) {
        path = '/e/' + this.enterprise_id + path
      }
      this.$router.push(path)
    },
    init () {
      var _self = this
      var _params = {
        position: _self.position,
        city: '深圳市'
      }
      if (_self.position !== 1) {
        _params.line_id = _self.line_id
      }
      _self.getNotice(_params).then(function (res) {
        if (res.data.title) {
          _self.show = true
          _self.notice = res.data.title
          _self.notice_id = res.data.id
          // 触发父组件显示通知
          _self.$emit('noticed', true)
        }
      })
    }
  },
  created () {
    var _self = this
    _self.init()
  }
}
</script>

<style lang="scss">
  .page-notice {
    position: relative;
    padding: 6px 0;
    margin: 0;
    max-width: 100%;
    background-color: #FFF5D7;
    font-size: 12px;
    color: #502000;
    box-sizing: border-box;
    z-index: 10;
    .content {
      display: block;
      margin: 0;
      padding: 0 40px 0 20px;
      line-height: 18px;
      font-size: 12px;
      color: #502000;
      max-width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .icon {
      position: absolute;
      top: 0;
      right: 0;
      display: inline-block;
      padding: 6px 20px 6px 10px;
      text-align: center;
      font-size: 12px;
      color: #502000;
      line-height: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// Notice.vue?3e631f12